export default "__VITE_ASSET__BO_SHmOf__"